import React from 'react';
import { Navigate } from 'react-router-dom';
import { canRead } from '../../constants/permissions';

const ReadPermissionRoute = ({ children }) => {
  if (!canRead()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ReadPermissionRoute;
